






























import Vue from 'vue';
import EmployeesTable from '@/components/Employees/EmployeesTable.vue';
import UserForm from '@/components/Employees/UserForm.vue';
import { mapState } from 'vuex';
import * as utils from '@/lib/utils';

export default Vue.extend({
    components: {
        EmployeesTable,
        UserForm,
    },
    computed: {
        ...mapState('employees', ['employees']),
        ...mapState('texts', ['employeesDetails']),
        ...mapState('tenants', ['tenants']),
    },
    data() {
        return {
            search: '',
            userFormOpen: false,
        };
    },
    methods: {
        exportToCsv() {
            const futureTicketsColumnTitle = `Future ${this.employeesDetails.tabTitle.toLowerCase()}`;
            const usedTicketsColumnTitle = `Used ${this.employeesDetails.tabTitle.toLowerCase()}`;

            // first line
            let csv = `Name,Email${this.tenants.length > 0 ? ',Tenant' : ''},Phone,Status,Group,${futureTicketsColumnTitle},${usedTicketsColumnTitle},Cancellations,No shows, Last used, Created\n`;

            // data lines
            this.employees.forEach((row: any) => {
                const phone = `${row.countryCode ? `+${row.countryCode}` : ''}${row.phone}`;
                const futureTickets = row.features?.upcoming_tickets || 0;
                const usedTickets = row.features?.used_tickets || 0;
                const cancelations = row.features?.canceled_tickets || 0;
                const notShows = row.features?.expired_tickets || 0;
                const lastUsed = row.features?.last_ticket_date ? utils.datetimeFormatToAmericanFormat(row.features?.last_ticket_date) : '';
                const created = row.created ? utils.convertDateToAmericanFormat(row.created) : '';
                const tenantName = this.tenants.find((t: any) => t.tenantId === row?.tenantId)?.firmName || '';
                // eslint-disable-next-line max-len
                csv += `${row.fullName},${row.email}${this.tenants.length > 0 ? `,${tenantName}` : ''},${phone},${row.status},${row.group},${futureTickets},${usedTickets},${cancelations},${notShows},${lastUsed},${created} \n`;
            });

            const fileName = 'employees.csv';
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            if (navigator && navigator.msSaveBlob) {
                // IE 10+
                navigator.msSaveBlob(blob, fileName);
            } else {
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', fileName);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
    },
});
